import React from 'react';

const SvgFlexi = props => (
  <svg viewBox="0 0 308.64 128.07" {...props}>
    <defs>
      <style>
        {'.flexi_svg__cls-1{fill:#fff}.flexi_svg__cls-3{fill:#05f}'}
      </style>
    </defs>
    <g id="flexi_svg__Layer_2" data-name="Layer 2">
      <g id="flexi_svg__Layer_1-2" data-name="Layer 1">
        <path
          className="flexi_svg__cls-1"
          d="M54.18 0v18.39h-8.71a12.2 12.2 0 00-3.28.49 9.25 9.25 0 00-3.28 1.81 8.61 8.61 0 00-2.63 3.61 12.25 12.25 0 00-1.15 5.91v18.06h19V66h-19v60.1h-19.7V66H0V48.27h15.43v-19c0-5.42.82-9.85 2.63-13.63a23.38 23.38 0 016.56-9 28 28 0 019.2-5.09A33.91 33.91 0 0143.67 0h10.51zM90.13 0v126.1h-19.7V0zM161.22 49.26a40.11 40.11 0 0112.47 8.21 43.35 43.35 0 018.38 12.8 42.13 42.13 0 013.12 16.59V90a37.14 37.14 0 01-.17 4.27H126.9a20.67 20.67 0 002.46 5.59 18.63 18.63 0 004.6 4.92 25.69 25.69 0 006.57 3.78 23.38 23.38 0 008.54 1.48 37.29 37.29 0 0010.67-1.81 27.7 27.7 0 0010.34-6.08l9.85 14.78a55.94 55.94 0 01-12.8 7.55 43.7 43.7 0 01-18.39 3.62 41.87 41.87 0 01-16.42-3.1 40.71 40.71 0 01-13.3-8.71 40.28 40.28 0 01-8.87-13.13 42.66 42.66 0 01-.32-32 42.57 42.57 0 018.21-13 39 39 0 0112.31-8.7A37.88 37.88 0 01146 46.3a39.54 39.54 0 0115.22 2.96zm2.95 25.45a21.29 21.29 0 00-3.61-5.26 19.9 19.9 0 00-6.08-3.77A22.54 22.54 0 00146 64.2a20.86 20.86 0 00-8.21 1.48 18.29 18.29 0 00-5.79 3.77 15.35 15.35 0 00-3.61 5.09A16.89 16.89 0 00126.9 80h38.58a16.3 16.3 0 00-1.31-5.29zM308.64 48.27v77.83h-19.7V48.27zM217.61 48.14l55.74 78.08h-23.48L194.54 48.4l23.07-.26z"
        />
        <path
          opacity={0.29}
          fill="#05f"
          d="M249.21 48.4l-56.8 77.82h22.32l56.98-77.82h-22.5z"
        />
        <path
          className="flexi_svg__cls-3"
          d="M232.57 101.89l-17.83 24.35h-22.33l29.11-39.89 11.05 15.54zM271.7 48.4l-27.29 37.29-11.09-15.53 15.89-21.76h22.49z"
        />
      </g>
    </g>
  </svg>
);

export default SvgFlexi;
